import React, { useState } from 'react';
import PropTypes from "prop-types"
import { Drawer, Toolbar, List, Hidden, SwipeableDrawer, Paper, Grid } from "@material-ui/core"
import useStyles from '../../hooks/useStyles'
import useFlyoutMenus from '../../hooks/modules/shell/useFlyoutMenus'
const Flyout = (props) => {
    const classes = useStyles()
    const { window, menuObj } = props
    const { mobileOpen, handleDrawerToggle, open } = menuObj
    const container = window !== undefined ? () => window().document.body : undefined;
    const [menus] = useFlyoutMenus(classes)
    const [miniMenuState, setMiniMenuState] = useState(false)
    const handleMouseOver = () => {
        if (!open) {
            setMiniMenuState(!miniMenuState)
        }
    }
    const drawerClass = open ? classes.drawerOpen : miniMenuState ? classes.drawerOpen : classes.drawerClose
    return (
        <nav className={classes.drawer}>
            <Hidden mdUp implementation="css">
                <SwipeableDrawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={() => handleDrawerToggle(true)}
                    onOpen={() => handleDrawerToggle(true)}
                    classes={{
                        paper: classes.drawerPaper,
                    }}

                    ModalProps={{
                        keepMounted: false,
                    }}>
                    <Paper classes={{ root: classes.paddedMenuMobile }} square elevation={4}>
                        <Grid item className={classes.title}>
                            <img src="../img/logo.svg" alt="Flexia" style={{ height: '1.5rem' }} />
                        </Grid>
                    </Paper>
                    <div className={classes.drawerContainer} onClick={() => handleDrawerToggle(true)}>
                        <List>
                            {menus}
                        </List>
                    </div>
                </SwipeableDrawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    variant="permanent"
                    classes={{
                        paper: drawerClass
                    }}
                    onMouseEnter={handleMouseOver}
                    onMouseLeave={handleMouseOver}>
                    <Toolbar />
                    <div className={classes.drawerContainer}>
                        <List>
                            {menus}
                        </List>
                    </div>
                </Drawer>
            </Hidden>
        </nav>
    );
}
Flyout.propTypes = {
    window: PropTypes.func,
};
export default Flyout;
